export const APP_LOCALE_ID: String = 'pt-BR';
